import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchShops } from '../store/shopSlice'; // Adjust the import path as necessary
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';

const ShopSelect = ({ onSelect, mouvementType, defaultShopId }) => {
  const dispatch = useDispatch();
  const [selectedShop, setSelectedShop] = useState('');
  const [visible, setVisible] = useState(false);

  const { shops, loading } = useSelector((state) => state.shop); // assumes slice key is 'shop'

  useEffect(() => {
    dispatch(fetchShops());
  }, [dispatch]);

  // Set selectedShop when shops are loaded and defaultShopId is provided
  useEffect(() => {
    if (shops.length > 0 && defaultShopId) {
      const found = shops.find((s) => s._id === defaultShopId);
      if (found) {
        setSelectedShop(found._id);
        if (onSelect) onSelect(found);
      }
    }
  }, [shops, defaultShopId, onSelect]);

  // Handle visibility based on mouvementType
  useEffect(() => {
    const allowedTypes = ['67f30a5fb65d87704511728f', '67f5010e985dcb0f516e6be7'];
    console.log('mouvementType', mouvementType);
    if (!mouvementType) {
      setVisible(true);
    } else {
      setVisible(allowedTypes.includes(mouvementType));
    }
  }, [mouvementType]);

  const handleChange = (event) => {
    const shopId = event.target.value;
    const shop = shops.find((s) => s._id === shopId);
    setSelectedShop(shopId);
    if (onSelect) onSelect(shop);
  };

  if (!visible) {
    return null;
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="select-shop-label">Select Shop</InputLabel>
      {loading ? (
        <CircularProgress size={24} sx={{ mt: 2 }} />
      ) : (
        <Select
          labelId="select-shop-label"
          value={selectedShop}
          label="Select Shop"
          onChange={handleChange}
        >
          {shops.map((shop) => (
            <MenuItem key={shop._id} value={shop._id}>
              {shop.name}
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default ShopSelect;
